export default "__VITE_ASSET__DdZ5uPXR__"